"use strict";

exports.__esModule = true;
exports.useForm = useForm;

var _react = require("react");

var _form = require("../context/form");

function useForm() {
  var form = (0, _react.useContext)(_form.FormContext);

  if (form == null) {
    throw new Error('useForm must be use with FormProvider');
  }

  return form;
}